<template>
  <div class="agreement-container">
    <div class="container-view">
        <h1>会员及续费协议</h1>
        <div class="meta">
            <p>更新时间：2025年06月30日</p>
        </div>

        <p>欢迎使用由广州心与潮信息科技有限公司(以下简称"心潮科技")提供的小睡眠会员及自动续费服务（以下称"本服务"），为让您更好地使用小睡眠提供的产品和服务，请您务必审慎阅读并充分理解《会员及续费协议》(以下称"本协议")所有内容。未成年人应在法定监护人陪同下阅读。若对本协议内容有任何疑问，请联系小睡眠客服。</p>
        <p>如您购买或使用本协议下的服务即表示已与小睡眠达成协议，并自愿接受并遵守本协议的全部约定。如您不同意本协议的任一条款内容，请不要以确认的形式进行下一步操作或使用本协议项下的服务。</p>

        <section>
            <h2>一、本服务协议的接受和修订</h2>
            <p><strong>1.1</strong> 本协议是心潮科技与您之间关于获取/使用小睡眠会员和/或自动续费服务的约定，为《用户协议》、《隐私政策》的补充协议，如本协议与上述协议存在冲突的，以本协议约定为准。心潮科技已经发布的或将来可能发布/更新的各类会员服务相关的规则，包括会员活动规则、权益说明、公告等均为本协议不可分割的组成部分，上述内容一经正式发布即生效，对双方均具有约束力。</p>
            <p><strong>1.2</strong> 本协议及相关服务条款如由于业务发展需要进行修订的，心潮科技将在小睡眠App上公布。您可前往查阅最新的协议条款。在心潮科技修改上述条款后，如果您不接受修改后的条款，您可以选择终止使用会员服务或自动续费服务。您继续使用本服务的，将被视为已接受了修改后的协议。更新后的协议自发布之日起生效。</p>
        </section>

        <section>
            <h2>二、会员及自动续费服务说明</h2>
            <p><strong>2.1</strong> 小睡眠会员服务，是指心潮科技为您提供的网络增值服务，包括会员、声音卡、宝宝卡等现有以及未来新增/调整的会员服务类型(具体会员类型以页面展示为准)。您在成为会员后可以依本协议以及页面展示的有效信息享有对应的会员服务，具体权益内容以小睡眠提供的为准。会员的所有权、运营权，以及会员制度、会员活动的制定权均归小睡眠所有。</p>
            <p><strong>2.2</strong> 自动续费服务包括"连续包月/连续包季/连续包半年/连续包年"，您同意并开通该服务，则视为您授权小睡眠开通自动续费服务，同时授权小睡眠在您所选定的计费周期即将到期时，从您指定的第三方支付账号，代扣下一计费周期的服务费用。</p>
            <p><strong>2.3</strong> 会员及自动续费服务期限说明：开通月度、季度、半年、年度会员后，您所获得的服务期限分别为 31 个自然日、 93 个自然日、 186 个自然日、 366 个自然日。有效服务期限以您选择并支付相应服务费用的期限为准。</p>
            <p><strong>2.4</strong> 您理解并同意，会员服务（包括会员、声音卡、宝宝卡）是一项网络增值服务，在已开通的会员服务有效期内，若您中途主动取消或终止会员资格，将不会获得会员开通费用的退还。</p>
        </section>

        <section>
            <h2>三、自动续费服务规则</h2>
            <p><strong>3.1</strong> 自动续费服务是在您开通小睡眠会员（包括会员、声音卡、宝宝卡）的基础上，出于您对自动续费的需求，避免您因疏忽或其他原因导致未及时续费而中断服务所推出的服务。自动续费分为连续包月、连续包季、连续包半年、连续包年等多种订阅服务期类型，对应计费周期分为包月费用、包季费用、包半年费用、包年费用。</p>
            <p><strong>3.2</strong> 如您开通自动续费服务，则视为您授权小睡眠在续费服务即将到期时，从您的自有充值账户、与小睡眠帐号绑定的第三方支付账户、银行卡、通讯账号（简称"账户"）等，代扣下一个计费周期的服务费用。</p>
            <ol style="position: relative">
                <li><span style="position: absolute;left: 8px">●</span> 如您通过苹果公司Apple ID开通本服务，且在下一个订阅服务到期前24小时前未主动取消本自动续费服务，则苹果公司将在每个订阅期即将到期前24小时，从您开通本自动续费服务时绑定的AppleID账户 (以下统称"账户")余额中自动代扣下一个订阅期服务费，从而延长该订阅期对应的服务有效期。</li>
                <li><span style="position: absolute;left: 8px">●</span> 如您通过安卓(Android) 产品开通本服务，且在订阅服务期内未主动取消本自动续费服务，则相关主体将在会员/声音卡/宝宝卡即将到期前一天开始，从您开通本自动续费服务时绑定的自有充值账户、绑定的第三方支付账户(包括但不限于微信钱包账户、支付宝账户) 、银行卡、通讯账号等账户 (以下统称"账户") 余额中自动代扣下一个会员期服务费，从而延长该订阅期对应的会员有效期。</li>
            </ol>
            <p><strong>3.3</strong> 您理解并同意，会员自动续费服务（包括会员订阅、声音卡订阅等服务形式）是一项网络增值服务，小睡眠会收取相应的互联网增值服务费。无论您是否在服务期限内实际使用或访问相关内容，已支付的费用不支持退费。</p>
            <p><strong>3.4</strong> 本服务取消成功后，不影响您已成功扣费且生效的会员服务，已生效的会员服务期满后不再自动续费。您在选择终止本服务前已经委托小睡眠自动续费扣款的指令仍然有效，小睡眠对于基于该指令扣除的费用不予退还，由您自行承担相关责任。</p>
            <p><strong>3.5</strong> 您理解并同意，因部分渠道由支付渠道根据实际情况自行决定扣费周期，前述自动续费服务的扣款时间以各渠道实际扣款时间为准。</p>
            <p><strong>3.6</strong> 请您关注上述各类账户及可扣款余额状况，如因账户问题或余额不足导致续费失败而引发的风险或导致的损失将由您自行承担 （如相应权益终止、无法参与活动、会员身份等）。如您未主动明确选择取消本服务，将视为您同意小睡眠在订阅服务期满后的一定期限内进行不时的扣款尝试（具体以各支付渠道的扣款规则为准）。小睡眠将在您账户余额恢复充足时/后，继续为您提供自动续费服务，一旦扣款成功，小睡眠将继续为您提供会员服务。</p>
            <p><strong>3.7</strong> 根据相关法律规定，为便于您知悉自动续费情况，小睡眠会在下一个订阅期扣款前5日以消息推送等方式通知您，第三方支付渠道也可能向您发出扣款前的提醒通知，请您注意接收。</p>
            <p><strong>3.8</strong> 如需取消自动续费服务，您可通过下述方式中止或终止本服务:</p>
            <ol style="position: relative">
                <li><span style="position: absolute;left: 8px">●</span> 苹果设备：因苹果公司相关规定，需要在苹果账号内对连续包年/包季/包月服务进行关闭和管理，方法如下：打开「设置」，进入iTunes Store 与 App Store」点击「Apple lD」，选择「查看Apple lD」进入「账户设置」页面，点击「订阅」，选择小睡眠，点击取消订阅即可。</li>
                <li><span style="position: absolute;left: 8px">●</span> 安卓其他用户：可通过【帮助与反馈】与客服联系，获取取消该服务的路径；也可直接在微信、支付宝等第三方支付客户端内取消自动扣款设置（具体操作方式以各产品实际功能为准）。</li>
            </ol>
        </section>

        <section>
            <h2>四、会员的获取与终止</h2>
            <p><strong>4.1</strong> 您可以在开通服务界面通过小睡眠认可的支付方式完成支付以开通会员服务。您在开通服务时，应仔细核对账号名称、开通服务类型、付费类型与服务期等具体信息。如因您个人原因造成充错账号、开通错服务或时长，小睡眠不予退还已收取的费用。</p>
            <p><strong>4.2</strong> 特别提醒您，一切在非官方渠道获取的会员资格或相关权益，将无法得到小睡眠的保护，请您谨慎选择、辨别购买渠道。如有疑问，可以咨询小睡眠客服。</p>
            <p><strong>4.3</strong> 您知悉并理解，会员服务是一项网络增值服务，在已开通的付费会员服务有效期内，若您中途主动取消或终止会员资格，将不会获得会员开通费用的退还；无论您是否在服务期限内访问或使用相关内容及服务，已支付的费用不支持退款。</p>
            <p><strong>4.4</strong> 付费会员资格取消/终止后，您不能再参加由小睡眠组织的活动，并不可再享有由小睡眠提供的各项特权服务及增值服务，即小睡眠不再为您提供相应的会员服务。</p>
        </section>

        <section>
            <h2>五、会员服务的使用规则</h2>
            <p><strong>5.1</strong> 会员服务仅限于申请账号个人使用，不得用于商业等用途；会员服务期内不能在小睡眠帐号之间转移，不得赠与、借用、转让或售卖。</p>
            <p><strong>5.2</strong> 为防止恶意共享账号或账号被盗等情况，保护您的账号安全，您理解并同意，小睡眠可对同一会员账号的登录及使用的设备数量进行一定限制，您须自行承担超范围使用而导致的任何后果。</p>
            <p><strong>5.3</strong> 如发生下列任何一种情形，小睡眠有权根据实际情况，在不通知您的情况下中断或终止向您提供的一项或多项或全部服务，由此产生的损失由您承担，小睡眠无需承担任何补偿和退费。若因此给小睡眠或第三方造成损失的，您应负责全额赔偿：</p>
            <ol style="position: relative">
                <li><span style="position: absolute;left: 8px">●</span> 以营利、经营等非个人使用目的为自己或他人开通本服务；</li>
                <li><span style="position: absolute;left: 8px">●</span> 将会员账号以出租、出借、出售等任何形式提供给第三方使用；</li>
                <li><span style="position: absolute;left: 8px">●</span> 将通过会员服务获得的任何内容用于个人学习、研究或欣赏之外的用途；</li>
                <li><span style="position: absolute;left: 8px">●</span> 以任何机器人软件、蜘蛛软件、爬虫软件、刷屏软件或其它非正规方式获得会员服务或参与任何会员活动；</li>
                <li><span style="position: absolute;left: 8px">●</span> 将会员提供的内容复制、销售、出租或授权给任何第三方；</li>
                <li><span style="position: absolute;left: 8px">●</span> 通过非小睡眠认可的方式获得会员所提供的内容、产品、服务；</li>
                <li><span style="position: absolute;left: 8px">●</span> 通过非法手段对会员账户的服务期限、消费金额、交易状态进行修改，或用非法的方式或为了非法的目的使用已购买的会员服务提供的内容；</li>
                <li><span style="position: absolute;left: 8px">●</span> 通过不正当手段或以违反诚实信用原则的行为获得付费会员服务或参与会员活动。</li>
            </ol>
        </section>
        
        <section>
            <h2>六、未成年人使用条款</h2>
            <p><strong>6.1</strong> 若您未满18周岁，则为未成年人，应在监护人监护、指导下阅读本协议和使用付费会员服务，并且已经获得监护人的同意。</p>
            <p><strong>6.2</strong> 若监护人同意未成年人使用小睡眠会员及自动续费服务，必须以监护人名义申请消费，未成年人使用小睡眠会员及自动续费服务时，以及行使和履行本协议项下的权利和义务即视为已获得了监护人的认可。</p>
            <p><strong>6.3</strong> 请未成年人用户注意保护个人信息，合理安排使用网络的时间，避免沉迷于网络，影响日常的学习生活。</p>
        </section>

        <section>
            <h2>七、免责声明</h2>
            <p><strong>7.1</strong> 如您购买/接受小睡眠以外的第三方商户提供的商品或服务，由此发生纠纷的，您应向销售/提供该商品或服务的第三方商户主张权利，与小睡眠无关。</p>
            <p><strong>7.3</strong> 小睡眠不对您因第三方的行为或不作为造成的损失，以及因不可抗力原因造成的损失承担任何责任，包括但不限于支付服务、网络接入服务、电信部门的通讯线路故障、通讯技术问题、网络、电脑故障、系统不稳定性、任意第三方的侵权行为等。</p>
            <p><strong>7.4</strong> 您理解并同意，在使用会员服务的过程中，可能会遇到不可抗力等风险因素，使该服务发生中断。如出现上述情况，小睡眠承诺将尽快与相关单位配合进行修复，但不承担由此对您造成的任何损失且不退还会员费用。</p>
        </section>

        <section>
            <h2>八、其他约定</h2>
            <p><strong>8.1</strong> 服务中止、中断及终止：心潮科技根据自身商业决策、政府行为、不可抗力等原因可能会选择更改、中止、中断及终止全部或部分会员服务。如有此等情形发生，心潮科技会通知您，但不承担由此对您造成的任何损失。</p>
            <p><strong>8.2</strong> 本服务协议的生效、履行、解释及争议的解决均适用于中华人民共和国法律，本服务条款因与中华人民共和国现行法律相抵触而导致部分无效，不影响其他部分的效力。</p>
            <p><strong>8.3</strong> 如您与心潮科技基于本协议发生任何纠纷或争议的，双方应尽量友好协商解决；协商不成时，您同意将纠纷或争议提交心潮科技所在地有管辖权的人民法院管辖。</p>
            <p><strong>8.4</strong> 心潮科技未行使、延迟行使，或未充分行使本协议或者按照法律规定所享有的权利，不应被视为放弃该权利，也不影响心潮科技在将来行使该权利。</p>
            <p><strong>8.5</strong> 如您对本协议内容有任何疑问，请发邮件至我们的客服邮箱：office@heartide.com。</p>
        </section>

        <div class="footer">
            <p>广州心与潮信息科技有限公司</p>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Home',
  mounted () {
    document.getElementsByTagName("title")[0].innerHTML="会员及续费协议"
  }
}
</script>
<style scoped>
.agreement-container {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    line-height: 1.8;
    background-color: #f8f9fa;
    color: #343a40;
    margin: 0;
    padding: 20px;
}

h1 {
    text-align: left;
    font-size: 32px;
    margin-bottom: 20px;
    color: #212529;
}
h2 {
    text-align: left;
    font-size: 20px;
    margin-top: 40px;
    margin-bottom: 20px;
    color: #495057;
    border-bottom: 2px solid #dee2e6;
    padding-bottom: 10px;
}
p {
    text-align: justify;
    font-size: 16px;
}
strong {
    font-weight: 600;
}
.meta {
    color: #6c757d;
    font-size: 14px;
    margin-bottom: 40px;
}
.meta p {
    margin: 0;
}
ol {
    padding-left: 32px;
}
li {
    margin-bottom: 16px;
    text-align: left;
    font-size: 14px;
}
.footer {
    margin-top: 50px;
    padding-top: 20px;
    border-top: 1px solid #eaeaea;
    font-size: 14px;
    color: #6c757d;
}
.footer p{
  text-align: right;
}
</style>
